import { render, staticRenderFns } from "./PageInvite.vue?vue&type=template&id=3441753a"
import script from "./PageInvite.vue?vue&type=script&lang=js"
export * from "./PageInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports